import { EntityLinks, Goal, ID, LifeArea } from '@griply/types';

import {
  buildGoalsById,
  getGoalTopLevelLifeAreas,
} from '../get-goal-life-area';
import { getPresentParentIds } from './get-present-parent-ids';

export type FilterLocalizedLifeAreasOptions = {
  goals: Goal[];
  showEmptyLifeAreas: boolean;
  // Must be the UNFILTERED set — a sub-goal's life area lives on an ancestor a filtered array has dropped.
  allGoals: Goal[];
  links: EntityLinks;
};

export const filterLocalizedLifeAreas = (
  lifeAreas: LifeArea[],
  {
    goals,
    showEmptyLifeAreas,
    allGoals,
    links,
  }: FilterLocalizedLifeAreasOptions,
): LifeArea[] => {
  if (showEmptyLifeAreas) {
    return lifeAreas.filter(({ archivedAt }) => !archivedAt);
  }

  const goalIds = new Set(goals.map(({ id }) => id));
  const goalsById = buildGoalsById(allGoals);
  const cache = new Map<ID, ID[]>();

  // A life area whose only goals link to it as a secondary life area is not empty.
  const filledIds = goals.reduce<Set<ID>>((acc, goal) => {
    const isNested = !!getPresentParentIds(goal, (id) => goalIds.has(id), {
      links,
      goalsById,
    }).length;
    getGoalTopLevelLifeAreas(goal, {
      isNested,
      goalsById,
      links,
      cache,
    }).forEach((lifeAreaId) => acc.add(lifeAreaId));
    return acc;
  }, new Set<ID>());

  return lifeAreas.filter(
    ({ id, archivedAt }) => !archivedAt && filledIds.has(id),
  );
};
